export default "__VITE_ASSET__a3485e2f__"